"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IQuadDestination.js.map